<template>
  <dl class="w-full pt-16">
    <div class="body-1-bold sr-only mb-24">
      {{ title }}
    </div>
    <div class="grid grid-cols-1 gap-x-48 md:grid-cols-2 lg:grid-cols-3">
      <div
        v-for="specification in specifications"
        :key="specification.display"
        class="border-static-default-low flex min-h-[40px] items-center justify-between border-t-1 py-8"
      >
        <dt class="body-1 leading-none">
          {{ specification.display }}
        </dt>
        <dd class="body-1-bold leading-none">
          <span
            v-for="value in specification.values"
            :key="value.label"
            class="ml-24 block text-right"
          >
            {{ value.label }}
          </span>
        </dd>
      </div>
    </div>
  </dl>
</template>

<script lang="ts" setup>
import type { GetTechnicalSpecificationsResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/technical-specifications'

defineProps<{
  title: string
  specifications: GetTechnicalSpecificationsResponse['specifications']
}>()
</script>
